module.exports = __webpack_public_path__ + "static/media/cv.5cf014a0.png";